import { HTTP_CODES } from '@cxc/core/enums';
import { Observable, retry, throwError, timer } from 'rxjs';

import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';

export function httpRetryInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  return next(req).pipe(
    retry({
      count: 3,
      delay: error => {
        if (
          [
            HTTP_CODES.REQUEST_TIMEOUT,
            HTTP_CODES.SERVICE_UNAVAILABLE,
            HTTP_CODES.GATEWAY_TIMEOUT,
            HTTP_CODES.CONNECTION_TIMEOUT,
            HTTP_CODES.NETWORK_CONNECT_TIMEOUT_ERROR,
          ].includes(error.status)
        ) {
          // Wait half a second
          return timer(500);
        }

        return throwError(() => error);
      },
    })
  );
}
